module.exports = __webpack_public_path__ + "media/main2.c95858d5.mp4";